import {localizedMessage} from 'epic-fortnite-react/components/message/Message';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import React from 'react';
import {Text, VisuallyHidden} from 'epic-fortnite-react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import epicTracking from 'epic-tracking';
import root from 'window-or-global';

const IconButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 3rem;
  padding: 0.5rem;
  line-height: 0;

  &[disabled] {
    opacity: 0.5;
  }

  &.favorited {
    background: #fff;
    color: red;
    opacity: 1;
  }
`;

const IconButtonCopyToClipboard = styled(CopyToClipboard)`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 3rem;
  padding: 0.5rem;
  line-height: 0;
`;

export default class HeaderSection extends React.Component {
  static propTypes = {
    imgUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    creator: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    descriptionTags: PropTypes.array,
    youtubeVideoId: PropTypes.string,
    version: PropTypes.number,
    arrowDescription: PropTypes.string.isRequired,
    addToFavorites: PropTypes.func.isRequired,
    addToPlaylist: PropTypes.func.isRequired,
    removeFromPlaylist: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    codeFavored: PropTypes.bool,
    isAddedToPlaylist: PropTypes.bool,
    error: PropTypes.string,
    active: PropTypes.bool,
    owner: PropTypes.bool,
    resetError: PropTypes.func,
    hideUGC: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.errRef = React.createRef();
    this.titleRef = React.createRef();
    this.taglineRef = React.createRef();
    this.youtubeRef = React.createRef();
    this.state = {
      copied: false,
      show: false,
    };
  }
  componentDidMount() {
    const dom = this.errRef.current;
    dom.addEventListener('animationend', ({animationName}) => {
      if (animationName === 'fade-in-and-out') {
        this.props.resetError();
      }
    });
  }

  handleCopy = () => {
    this.setState({copied: true});
    setTimeout(() => this.setState({copied: false}), 2000);

    if (root._epicTracking) {
      epicTracking.trackEvent('Interaction', {
        eventCategory: 'copy',
        eventAction: 'cta',
        eventLabel: 'copy_Creative_island',
        eventValue: 'TRUE',
        interactionType: 'click',
      });
    }
  };

  toggleOverlay = (e) => {
    e.stopPropagation();
    this.setState(Object.assign(this.state, {show: !this.state.show}));
  };

  render() {
    const {
      creator,
      code,
      title,
      tagline,
      addToFavorites,
      addToPlaylist,
      removeFromPlaylist,
      codeFavored,
      isAddedToPlaylist,
      //descriptionTags,
      error,
      addFavoriteCodeLoading,
      imgUrl,
      hideUGC,
    } = this.props;

    // const getCtaButtonText = (codeFavored) => {
    //   let buttonText = addFavorites;
    //   if (addFavoriteCodeLoading) {
    //     buttonText = localizedMessage('epic.common.loading');
    //   } else if (codeFavored) {
    //     buttonText = favoritesAdded;
    //   }
    //   return buttonText;
    // };

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    return (
      <div className="creative-island-header">
        <span ref={this.errRef} className={`fade ${error ? 'error' : ''}`}>
          <span className="icon-warning"></span>
          <span className="errMsg">{error}</span>
        </span>
        <div className="creative-island-bg" style={{backgroundImage: `url(${imgUrl})`}}></div>
        <div className="creative-island-content-wrapper">
          <div className="creative-island-content">
            <div className="creative-island-creator-tag">
              <Text size="xl">
                <svg
                  style={{width: '1em', height: '1em', fill: 'currentColor'}}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.102 16.567c.8-2.566 6.118-3.962 8.898-3.962 2.766 0 8.096 1.396 8.898 3.963A10 10 0 0 1 12 22a10 10 0 0 1-8.898-5.433ZM12 2C9.51 2 7.5 3.998 7.5 6.474c0 2.475 2.01 4.474 4.5 4.474s4.5-1.999 4.5-4.474C16.5 3.998 14.49 2 12 2Z"
                    clipRule="evenodd"
                  />
                </svg>
              </Text>
              <Text as="h3" size="xl" transform="uppercase">
                <span>{creator}</span>
              </Text>
            </div>
            <h1>{hideUGC ? code : title}</h1>
            <div className="creative-island-button-group">
              {!isAddedToPlaylist ? (
                <button
                  className={`btn btn-primary`}
                  disabled={isAddedToPlaylist}
                  onClick={addToPlaylist}>
                  {localizedMessage('epic.common.addToPlaylist')}
                </button>
              ) : (
                <button
                  className={`btn btn-primary`}
                  disabled={!isAddedToPlaylist}
                  onClick={removeFromPlaylist}>
                  {localizedMessage('epic.common.removeFromPlaylist')}
                </button>
              )}

              <IconButton
                className={`${codeFavored ? 'favorited' : ''}`}
                disabled={codeFavored || addFavoriteCodeLoading}
                onClick={addToFavorites}
                title="Add to Favorites">
                <svg
                  style={{width: '1em', height: '1em', fill: 'currentColor'}}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m12 21-7.378-8.146C-.297 7.423 7.082 0 12 6.699c4.919-6.789 12.297.724 7.378 6.155L12 21Z"
                    clipRule="evenodd"
                  />
                </svg>
              </IconButton>
              {/* <IconButton>
                <svg
                  style={{width: '1em', height: '1em', fill: 'currentColor'}}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 6a3 3 0 0 1-4.91 2.313l-5.15 3.089a3.013 3.013 0 0 1 0 1.196l5.15 3.09a3 3 0 1 1-1.03 1.715l-5.15-3.09a3 3 0 1 1 0-4.626l5.15-3.089A3 3 0 1 1 19 6Z" />
                </svg>
              </IconButton> */}
            </div>
            <p className="creative-island-tagline">{tagline}</p>
            <div className="creative-island-code-wrapper">
              {/* <CopyToClipboardCode className="island-header-code" code={code} /> */}
              <Text as="h3" color="#fff" size="xl" transform="uppercase">
                {code}
              </Text>
              <IconButtonCopyToClipboard
                onCopy={this.handleCopy}
                text={code}
                title={localizedMessage('epic.common.copyToClipboard')}>
                {this.state.copied ? (
                  <div>
                    <VisuallyHidden>{localizedMessage('epic.common.copied')}</VisuallyHidden>
                    <svg
                      style={{width: '1em', height: '1em', fill: 'currentColor'}}
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        d="M19.7072 7.70712L9.00008 18.4142L4.29297 13.7071L5.70718 12.2929L9.00008 15.5858L18.293 6.29291L19.7072 7.70712Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                ) : (
                  <div>
                    <VisuallyHidden>
                      {localizedMessage('epic.common.copyToClipboard')}
                    </VisuallyHidden>
                    <svg
                      style={{width: '1em', height: '1em', fill: 'currentColor'}}
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.269 21a5.242 5.242 0 0 1-3.727-1.538 5.281 5.281 0 0 1 0-7.46l2.795-2.794 1.24 1.239-2.795 2.794a3.52 3.52 0 0 0 0 4.974 3.523 3.523 0 0 0 4.974 0l2.795-2.795 1.24 1.24-2.795 2.802A5.257 5.257 0 0 1 8.269 21Zm11.188-8.998a5.281 5.281 0 0 0 0-7.46 5.284 5.284 0 0 0-7.461 0L9.2 7.345l1.239 1.24 2.795-2.795a3.523 3.523 0 0 1 4.974 0 3.52 3.52 0 0 1 0 4.973l-2.794 2.794 1.239 1.24 2.803-2.795Zm-4.35-1.863L13.867 8.9l-4.974 4.974 1.24 1.239 4.974-4.974Z" />
                    </svg>
                  </div>
                )}
              </IconButtonCopyToClipboard>
            </div>

            {hideUGC ? (
              <div className="creative-island-details-unavailable-message">
                <svg
                  style={{width: '28px', height: '27px', fill: 'currentColor', marginRight: '10px'}}
                  viewBox="0 0 28 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 26.865c7.364 0 13.333-5.97 13.333-13.333C27.333 6.168 21.363.198 14 .198 6.636.198.667 6.168.667 13.532c0 7.363 5.969 13.333 13.333 13.333Zm-1.667-11.667V6.865h3.333v8.333h-3.333Zm0 5v-3.333h3.333v3.333h-3.333Z"
                    fill="#37178D"
                  />
                </svg>
                {localizedMessage('epic.fortnite.islandUnavailable')}
              </div>
            ) : null}
          </div>
          <div className="creative-island-img">
            <img src={imgUrl} alt={`${title} ${code} by ${creator}`} />
          </div>
        </div>
      </div>
    );
  }
}
